/**
 * Duck-typed 401 check, deliberately independent of any `@angular/common/http`
 * class import (e.g. `instanceof HttpErrorResponse`) so this decision logic
 * stays trivially unit-testable with plain objects.
 */
export function isUnauthorizedError(error: unknown): boolean {
  return (
    typeof error === 'object' &&
    error !== null &&
    'status' in error &&
    (error as { status: unknown }).status === 401
  )
}
